var map = {
	"./diamond-clarity-1.png": 129,
	"./diamond-clarity-1@2x.png": 88,
	"./diamond-clarity-1@3x.png": 89,
	"./diamond-clarity-2.png": 130,
	"./diamond-clarity-2@2x.png": 90,
	"./diamond-clarity-2@3x.png": 91,
	"./diamond-clarity-3.png": 131,
	"./diamond-clarity-3@2x.png": 92,
	"./diamond-clarity-3@3x.png": 93,
	"./diamond-clarity-4.png": 132,
	"./diamond-clarity-4@2x.png": 94,
	"./diamond-clarity-4@3x.png": 95,
	"./diamond-clarity-5.png": 133,
	"./diamond-clarity-5@2x.png": 96,
	"./diamond-clarity-5@3x.png": 97
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 258;